module.exports = __webpack_public_path__ + "assets/9fb35a2146f0c7c371e4ee1ef6712930.png";